import ListingApis from 'src/api/listings';
import { differenceInDays, format } from 'date-fns';
import { FormikValues } from 'formik';
import { useNotifier } from 'src/contexts/notification/notification.context';
import useUser from 'src/hooks/auth/useUser';

const usePostListing = () => {
  const { accessToken, user } = useUser();
  const { successAlert, errorAlerts, errorAlert } = useNotifier();
  const postListing = async (values: FormikValues) => {
    try {
      const rentPer = differenceInDays(values.endDate, values.startDate);
      const model = new FormData();
      model.append('title', values.title);
      model.append('short_description', values.description);
      model.append('expected_price', values.expectedPrice);
      model.append('rental_value_per_period', values.rentValue);
      model.append('rental_period', rentPer.toString());
      model.append('rent_per', values.rentPer);
      model.append('availability_from', format(new Date(values.startDate), 'yyyy-MM-dd'));
      model.append('availability_to', format(new Date(values.endDate), 'yyyy-MM-dd'));
      model.append('is_rent_negotiable', values.isNegotiable);
      model.append('address', values.address);
      model.append('place_id', values.place_id);
      model.append('condition', values.condition);
      Array.from(values.images).map((image: any) => model.append('listingImage[]', image));
      model.append('user_id', user?.id.toString() || '');
      model.append('child_category_id', values.childCategory.id);
      model.append('parent_category_id', values.parentCategory.id);
      // Properties
      values.childCategory.properties.map((property: any) => {
        return Object.keys(values).forEach((key) => {
          if (key === property.name) {
            if (property.possible_options) {
              model.append(key.toLowerCase(), values[key][0].label);
            } else {
              model.append(key.toLowerCase(), values[key]);
            }
          }
        });
      });
      const result = await ListingApis.createListing({ token: accessToken, model });
      if (result.status === 200) {
        successAlert(result.data.message);
        return true;
      }
      if (result.data.errors) {
        errorAlerts(Object.values(result.data.errors));
        return false;
      }
      errorAlert(result.data.message);
      return false;
    } catch (error) {
      console.log(error);
      errorAlert('Something went wrong');
      return false;
    }
  };
  const postWantedListing = async (values: FormikValues) => {
    try {
      const model = new FormData();
      model.append('title', values.title);
      model.append('short_description', values.description);
      model.append('expected_price', values.expectedPrice);
      model.append('rental_value_per_period', values.rentValue);
      model.append('condition', values.condition);
      model.append('rental_period', values.rentPeriod);
      model.append('address', values.address);
      model.append('place_id', values.place_id);
      Array.from(values.images).map((image: any) => model.append('listingImage[]', image));
      model.append('user_id', user?.id.toString() || '');
      model.append('child_category_id', values.childCategory.id);
      model.append('parent_category_id', values.parentCategory.id);
      // Properties
      values.childCategory.properties.map((property: any) => {
        // eslint-disable-next-line array-callback-return
        return Object.keys(values).map((key) => {
          if (key === property.name) {
            if (property.possible_options) {
              model.append(key.toLowerCase(), values[key][0].label);
            } else {
              model.append(key.toLowerCase(), values[key]);
            }
          }
        });
      });
      const result = await ListingApis.createWantedListing({ token: accessToken, model });
      if (result.status === 200) {
        successAlert(result.data.message);
        return true;
      }
      if (result.data.errors) {
        errorAlerts(Object.values(result.data.errors));
        return false;
      }
      errorAlert(result.data.message);
      return false;
    } catch (error) {
      console.log(error);
      errorAlert('Something went wrong');
      return false;
    }
  };
  return {
    postListing,
    postWantedListing,
  };
};
export default usePostListing;
